import React from 'react';
import logo from './logo.svg';
import './App.css';
import RouterApp from './Route/RouterApp';

function App() {
  return (
  <>
   <RouterApp />
  </>
  );
}

export default App;
